import { FETCH_LANDINGS } from "./mutation-types";

import service from "@/service";
import config from "@/config";
import axios from "axios";

const $service = service(axios, config);

export default {
  async applyGetAllLandings({ commit }, data) {
    let dept = await $service
      .getLandingList(data)
      .then((res) => {
        return {
          data: res.data,
          status: res.status,
        };
      })
      .catch((error) => {
        // console.log(error);
        return {
          msg: error.response.data.message,
          status: error.response.data.code,
        };
      });

    if (dept.status == 200) {
      commit(FETCH_LANDINGS, dept.data);
      return dept;
    }
    return { ...dept, status: 400 };
  },
};
